import { Close } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { startMeshLinksAnalysis } from "../../../pages/postEditor/seoAnalyzer/links";
import { setActivePanel } from "../../../redux/slices/panelSlice";
import { dispatch } from "../../../redux/store";
import { LaunchAnalysisBtn } from "../Others";

const Linking = () => {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state?.auth.userInfo);
  const formikProps = useFormikContext();
  const [analysis, setAnalysis] = useState();
  const [linkingTable, setLinkingTable] = useState();

  const competitorResults = useSelector(
    (state) => state.competitorAnalysis.data?.data
  );
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    const analyze = startMeshLinksAnalysis(formikProps, competitorResults);

    setAnalysis(analyze);
  }, [formikProps.values]);

  // Close Panel
  const handleClose = () => {
    dispatch(setActivePanel(null));
  };
  // Close/Open Linking Table
  const handleModal = (data) => {
    if (data.type === "linking") {
      setShowModal(data.show);
      setLinkingTable(data.linkingTable);
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        overflow: "auto",
        height: { md: "100vh", xs: "100%" },
        width: "auto",
        display: "flex",
        flexDirection: { md: "row", xs: "column" },
        mt: { md: "48px !important", xs: "unset !important" },

        top: 0,
        bgcolor: showModal ? "#000000a1" : "transparent",
        zIndex: 9999,
      }}
      className={`${showModal ? "left-0" : "right-0"}`}
    >
      <Box
        className={`${showModal ? "flex" : "hidden"}`}
        sx={{
          width: {
            lg: "calc(100vw - 500px)",
            md: "calc(100vw - 350px)",
            xs: "100%",
          },

          justifyContent: "center",
          height: "auto",
          //overflow: { md: 'auto', xs: 'unset' },
        }}
      >
        <Box
          sx={{
            width: "100%",
            my: { md: "unset", xs: "40px" },
          }}
        >
          <div className="h-screen flex">
            <Box
              sx={{
                maxHeight: "95%",
                height: "90%",
                mx: "auto",
                mt: 4,
                bgcolor: "white",
                maxWidth: "95%",
                width: "90%",
                borderRadius: 4,
                overflow: "hidden",
                display: "flex",

                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  py: 2,
                  px: 3,
                  position: "relative",
                  borderBottom: "2px solid #e5e7eb",
                }}
              >
                <p className="text-2xl font-semibold">
                  {t("Table_of_links", "Table of links")}
                </p>
                <Box
                  onClick={() => {
                    handleModal({
                      linkingTable: null,
                      show: false,
                      type: "linking",
                    });
                  }}
                  sx={{
                    position: "absolute",
                    cursor: "pointer",
                    right: 0,
                    top: 0,
                    p: 2,
                  }}
                >
                  <Close sx={{ color: "black", fontSize: 32 }} />
                </Box>
              </Box>
              <Box
                sx={{
                  bgcolor: "white",
                  px: 3,
                  py: 2,
                  flex: 1,
                  overflow: "auto",
                }}
              >
                {/* Linking Table */}
                <div className="w-full mt-5 overflow-x-auto">
                  {/* Own Page Linking Table */}
                  {competitorResults?.pageLinks?.table && (
                    <p className="text-xl font-semibold mb-3">
                      {t("Your_table_of_links", "Your table of links")}
                    </p>
                  )}
                  <table className=" w-full border-collapse text-xs text-center break-words">
                    <thead>
                      <tr className=" ">
                        <th className="bg-stone-400  text-black py-2 border-neutral-500  border-b-[1px] rounded-tl-lg max-96">
                          {t("Link_URL", "Link URL")}
                        </th>
                        <th className="bg-stone-400 text-black py-2 border-neutral-500  border-l-[1px] border-b-[1px] border-r-[1px] w-24">
                          {t("Link_type", "Link type")}
                        </th>
                        <th className="bg-stone-400 text-black py-2 border-neutral-500  border-l-[1px] border-b-[1px] border-r-[1px] w-32 ">
                          {t("Attributes", "Attributes")}
                        </th>
                        <th className="bg-stone-400 text-black py-2 border-neutral-500  border-l-[1px] border-b-[1px] border-r-[1px] w-24">
                          {t("Is_duplicate?", "Is duplicate ?")}
                        </th>
                        <th className="bg-stone-400 text-black py-2 border-neutral-500  border-l-[1px] border-b-[1px] border-r-[1px]">
                          {t("Link_anchor", "Link anchor")}
                        </th>
                        <th className="bg-stone-400 text-black py-2 border-neutral-500  border-l-[1px] border-b-[1px] border-r-[1px] w-24">
                          {t("Anchor_type_text", "Anchor type text")}
                        </th>
                        <th className="bg-stone-400 text-black py-2 border-neutral-500  border-l-[1px] border-b-[1px] border-r-[1px]">
                          {t("Anchor_length", "Anchor length")}
                        </th>
                        <th className="bg-stone-400 text-black py-2 border-neutral-500   border-b-[1px] rounded-tr-lg w-24">
                          {t("Anchor_type", "Anchor type")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {linkingTable &&
                        linkingTable?.table.map((item, index) => {
                          return (
                            <>
                              <tr>
                                <td
                                  className={` ${
                                    index + 1 == linkingTable?.table?.length
                                      ? "rounded-bl-lg "
                                      : " border-b-[1px] "
                                  }  bg-stone-200 text-black  border-neutral-500  px-4 py-2 max-w-96 break-words`}
                                >
                                  {item?.url}
                                </td>
                                <td
                                  className={` ${
                                    index + 1 == linkingTable?.table?.length
                                      ? ""
                                      : "border-b-[1px]"
                                  }  text-black  border-l-[1px] border-r-[1px]   border-neutral-500 py-2 px-4 capitalize  break-words ${
                                    item?.link_type.toLowerCase() === "internal"
                                      ? "bg-sky-300"
                                      : "bg-sky-400"
                                  }`}
                                >
                                  {item?.link_type}
                                </td>
                                <td
                                  className={`${
                                    index + 1 == linkingTable?.table?.length
                                      ? ""
                                      : "border-b-[1px]"
                                  } bg-stone-200 text-black  border-l-[1px] border-r-[1px]   border-neutral-500 px-4 break-words py-2`}
                                >
                                  {item?.attributes}
                                </td>
                                <td
                                  className={` ${
                                    index + 1 == linkingTable?.table?.length
                                      ? ""
                                      : "border-b-[1px]"
                                  } ${
                                    !item?.is_duplicated
                                      ? "bg-lime-500"
                                      : "bg-yellow-500"
                                  } px-4 break-words text-black   border-l-[1px] border-r-[1px] border-neutral-500 py-2`}
                                >
                                  {item?.is_duplicated
                                    ? t("Yes", "Yes")
                                    : t("No", "No")}
                                </td>
                                <td
                                  className={`${
                                    index + 1 == linkingTable?.table?.length
                                      ? ""
                                      : "border-b-[1px]"
                                  } bg-stone-200 text-black border-l-[1px] border-r-[1px] border-neutral-500 px-4 py-2 break-words`}
                                >
                                  {item?.anchor}
                                </td>
                                <td
                                  className={`${
                                    index + 1 == linkingTable?.table?.length
                                      ? ""
                                      : "border-b-[1px]"
                                  } ${
                                    item?.anchor_type
                                      .toLowerCase()
                                      .includes("image")
                                      ? "bg-stone-400"
                                      : "bg-stone-200"
                                  } break-words px-4 text-black    border-l-[1px] border-r-[1px] border-neutral-500 py-2`}
                                >
                                  {item?.anchor_type}
                                </td>
                                <td
                                  className={` ${
                                    index + 1 == linkingTable?.table?.length
                                      ? ""
                                      : "border-b-[1px]"
                                  }  ${
                                    item?.anchor_length?.nb_characters > 5 &&
                                    item?.anchor_length?.nb_characters < 80
                                      ? "bg-lime-500"
                                      : "bg-yellow-500"
                                  }  text-black  border-l-[1px] border-r-[1px] border-neutral-500 py-2`}
                                >
                                  {item?.anchor_length?.nb_words}{" "}
                                  {t("word", "word")}
                                  {item?.anchor_length?.nb_words > 1
                                    ? "s"
                                    : ""}{" "}
                                  ({item?.anchor_length?.nb_characters}{" "}
                                  {t("character", "character")}
                                  {item?.anchor_length?.nb_characters > 1
                                    ? "s"
                                    : ""}
                                  )
                                </td>
                                <td
                                  className={`${
                                    index + 1 == linkingTable?.table?.length
                                      ? "rounded-br-lg "
                                      : " border-b-[1px] "
                                  } ${
                                    item?.anchor_text_type.toLowerCase() ===
                                    "branded"
                                      ? "bg-rose-500"
                                      : "bg-rose-400"
                                  } break-words px-4 text-black    border-neutral-500 py-2 `}
                                >
                                  {item?.anchor_text_type}
                                </td>
                              </tr>
                            </>
                          );
                        })}
                      {linkingTable && linkingTable?.table?.length == 0 && (
                        <tr>
                          <td
                            colSpan={8}
                            className={`bg-stone-200 text-red-600 font-bold rounded-br-lg rounded-bl-lg border-neutral-500 py-2 text-center`}
                          >
                            {t("no-data-found", "No data found")}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {/* Competitors Linking Table */}
                  {competitorResults?.pageLinks?.table && (
                    <>
                      <p className="text-xl font-semibold mb-3 mt-5">
                        {t("table_of_links", "Table of links")} {t("of", "of")}{" "}
                        {
                          competitorResults?.contents[
                            competitorResults?.pageLinks?.id
                          ]?.website_name
                        }{" "}
                        ({" "}
                        {
                          competitorResults?.contents[
                            competitorResults?.pageLinks?.id
                          ]?.url?.full
                        }
                        )
                      </p>
                      <table className=" w-full border-collapse text-xs text-center break-words ">
                        <thead>
                          <tr>
                            <th className="bg-stone-400 text-black py-2 max-w-96 border-neutral-500 rounded-tl-lg border-b-[1px] ">
                              {t("Link", "Link")}
                            </th>
                            <th className="bg-stone-400 text-black py-2 border-neutral-500 border-l-[1px] border-r-[1px] border-b-[1px]  w-24">
                              {t("Link_type", "Link type")}
                            </th>
                            <th className="bg-stone-400 text-black py-2 border-neutral-500  border-l-[1px] border-r-[1px] border-b-[1px]  w-32 ">
                              {t("Attributes", "Attributes")}
                            </th>
                            <th className="bg-stone-400 text-black py-2 border-neutral-500  border-l-[1px] border-r-[1px] border-b-[1px]  w-24">
                              {t("Is_duplicate?", "Is duplicate ?")}
                            </th>
                            <th className="bg-stone-400 text-black py-2 border-neutral-500  border-l-[1px] border-r-[1px] border-b-[1px] ">
                              {t("Link_anchor", "Link anchor")}
                            </th>
                            <th className="bg-stone-400 text-black py-2 border-neutral-500  border-l-[1px] border-r-[1px] border-b-[1px]  w-24">
                              {t("Anchor_type_text", "Anchor type text")}
                            </th>
                            <th className="bg-stone-400 text-black py-2 border-neutral-500  border-l-[1px] border-r-[1px] border-b-[1px]  ">
                              {t("Anchor_length", "Anchor length")}
                            </th>
                            <th className="bg-stone-400 text-black py-2 w-24 border-neutral-500  rounded-tr-lg border-b-[1px] ">
                              {t("Anchor_type", "Anchor type")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {competitorResults &&
                            competitorResults?.pageLinks?.table?.map(
                              (item, index) => {
                                return (
                                  <>
                                    <tr>
                                      <td
                                        className={`${
                                          index + 1 ==
                                          competitorResults?.pageLinks?.table
                                            ?.length
                                            ? "rounded-bl-lg "
                                            : " border-b-[1px] "
                                        }bg-stone-200 text-black    border-neutral-500 py-2 max-w-96 px-4 break-words`}
                                      >
                                        {item?.url}
                                      </td>
                                      <td
                                        className={`${
                                          index + 1 ==
                                          competitorResults?.pageLinks?.table
                                            ?.length
                                            ? ""
                                            : "border-b-[1px]"
                                        }  text-black  border-l-[1px] border-r-[1px]   border-neutral-500 py-2 capitalize px-4 break-words ${
                                          item?.link_type.toLowerCase() ===
                                          "internal"
                                            ? "bg-sky-300"
                                            : "bg-sky-400"
                                        }`}
                                      >
                                        {item?.link_type}
                                      </td>
                                      <td
                                        className={`${
                                          index + 1 ==
                                          competitorResults?.pageLinks?.table
                                            ?.length
                                            ? ""
                                            : "border-b-[1px]"
                                        } bg-stone-200 text-black  border-l-[1px] border-r-[1px] border-neutral-500 py-2 break-words`}
                                      >
                                        {item?.attributes}
                                      </td>
                                      <td
                                        className={`${
                                          index + 1 ==
                                          competitorResults?.pageLinks?.table
                                            ?.length
                                            ? ""
                                            : "border-b-[1px]"
                                        } ${
                                          !item?.is_duplicated
                                            ? "bg-lime-500"
                                            : "bg-yellow-500"
                                        } px-4 break-words text-black  border-l-[1px]  border-r-[1px]   border-neutral-500 py-2`}
                                      >
                                        {item?.is_duplicated
                                          ? t("Yes", "Yes")
                                          : t("No", "No")}
                                      </td>
                                      <td
                                        className={`${
                                          index + 1 ==
                                          competitorResults?.pageLinks?.table
                                            ?.length
                                            ? ""
                                            : "border-b-[1px]"
                                        } bg-stone-200 text-black border-l-[1px] border-r-[1px] border-neutral-500 py-2 px-4 break-words`}
                                      >
                                        {item?.anchor}
                                      </td>
                                      <td
                                        className={`${
                                          index + 1 ==
                                          competitorResults?.pageLinks?.table
                                            ?.length
                                            ? ""
                                            : "border-b-[1px]"
                                        } ${
                                          item?.anchor_type
                                            .toLowerCase()
                                            .includes("image")
                                            ? "bg-stone-400"
                                            : "bg-stone-200"
                                        } break-words px-4 text-black  border-l-[1px] border-r-[1px]   border-neutral-500 py-2`}
                                      >
                                        {item?.anchor_type}
                                      </td>
                                      <td
                                        className={`${
                                          index + 1 ==
                                          competitorResults?.pageLinks?.table
                                            ?.length
                                            ? ""
                                            : "border-b-[1px] "
                                        }${
                                          item?.anchor_length?.nb_characters >
                                            5 &&
                                          item?.anchor_length?.nb_characters <
                                            80
                                            ? "bg-lime-500"
                                            : "bg-yellow-500"
                                        }  text-black  border-l-[1px] border-r-[1px]  border-neutral-500 py-2 px-4 break-words`}
                                      >
                                        {item?.anchor_length?.nb_words}{" "}
                                        {t("word", "word")}
                                        {item?.anchor_length?.nb_words > 1
                                          ? "s"
                                          : ""}{" "}
                                        ({item?.anchor_length?.nb_characters}{" "}
                                        {t("character", "character")}
                                        {item?.anchor_length?.nb_characters > 1
                                          ? "s"
                                          : ""}
                                        )
                                      </td>
                                      <td
                                        className={`${
                                          index + 1 ==
                                          competitorResults?.pageLinks?.table
                                            ?.length
                                            ? "rounded-br-lg "
                                            : " border-b-[1px]"
                                        } ${
                                          item?.anchor_text_type.toLowerCase() ===
                                          "branded"
                                            ? "bg-rose-500"
                                            : "bg-rose-400"
                                        } break-words px-4 text-black   border-neutral-500 py-2 `}
                                      >
                                        {item?.anchor_text_type}
                                      </td>
                                    </tr>
                                  </>
                                );
                              }
                            )}
                          {competitorResults &&
                            competitorResults?.pageLinks?.table?.length ==
                              0 && (
                              <tr>
                                <td
                                  colSpan={8}
                                  className={`bg-stone-200 text-red-600 font-bold   rounded-br-lg rounded-bl-lg border-neutral-500 py-2 text-center`}
                                >
                                  {t("no-data-found", "No data found")}
                                </td>
                              </tr>
                            )}
                        </tbody>
                      </table>
                    </>
                  )}
                </div>
              </Box>
            </Box>
          </div>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: "#303539",
          height: "100vh",
          width: { lg: "500px", md: "350px", xs: "100%" },
          color: "white",
          pb: 5,
        }}
        className="overflow-y-scroll"
      >
        <Box
          sx={{
            backgroundColor: "#3e4756",
            p: 2,
            position: "relative",
          }}
        >
          <Box
            onClick={handleClose}
            sx={{
              position: "absolute",
              cursor: "pointer",
              right: 0,
              top: 0,
              p: 2,
            }}
          >
            <Close sx={{ color: "white" }} />
          </Box>
          <h1 className="text-2xl mb-2">
            {t("Interna-and-external-linking", "Maillage (interne et externe)")}
          </h1>

          <p className="text-xs mb-2">
            {t(
              "tutorial-text-linking",
              "Le maillage (ajout de liens au contenu) est un aspect essentiel du SEO : il ajoute des informations utiles, organise le contenu et tisse des relations entre les pages du web. Suivez nos conseils pour optimiser votre maillage !"
            )}
          </p>

          {/* <p className="text-xs">
            {t("For-more-info:", "Pour plus d'infos :")}{" "}
            <span>
              <a className="text-blue-500 underline cursor-pointer">
                {
                  ("linking-optimization-guide",
                  "Créer un bon maillage interne et externe en SEO : le Guide Complet 2024")
                }
              </a>
            </span>
          </p> */}
        </Box>

        <LaunchAnalysisBtn
          userInfo={userInfo}
          formikProps={formikProps}
          disabled={true}
          analysis={analysis}
          showModal={showModal}
          showModalHandle={handleModal}
          type={"linking"}
        />
      </Box>
    </Box>
  );
};

export default Linking;
